/* eslint-disable react/jsx-handler-names */
import useDrag from "./useDrag.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function Drag(_ref) {
  let {
    captureDragArea = true,
    snapToPointer = true,
    children,
    dx,
    dy,
    height,
    onDragEnd,
    onDragMove,
    onDragStart,
    resetOnStart,
    width,
    x,
    y,
    isDragging,
    restrict,
    restrictToPath
  } = _ref;
  const drag = useDrag({
    resetOnStart,
    snapToPointer,
    onDragEnd,
    onDragMove,
    onDragStart,
    x,
    y,
    dx,
    dy,
    isDragging,
    restrict,
    restrictToPath
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [drag.isDragging && captureDragArea && /*#__PURE__*/_jsx("rect", {
      width: width,
      height: height,
      onPointerDown: drag.dragStart,
      onPointerMove: drag.dragMove,
      onPointerUp: drag.dragEnd,
      fill: "transparent"
    }), children(drag)]
  });
}